import { Locale } from './_types';

export interface TranslationKeys {
  welcomeTo: string;
  printingToken: string;
  yourQueueNumber: string;
  getTicketHere: string;
  getPaperTicketHere: string;
  otherServices: string;
  digitalTicketOnPhone: string;
  scanQrForDigitalTicket: string;
  scanQrDigitalUpdates: string;
  cannotPrintPaperTicket: string;
  forPaperTicket: string;
  qrBased_savePaper: string;
  qrBased_useMobileCamera: string;
  qrBased_instructions: string;
  qrBased_instructionStep1: string;
  qrBased_instructionStep2: string;
  qrBased_instructionStep3: string;
  qrBased_instructionStep4: string;
  printer_noPaper: string;
  printer_couldNotPrint: string;
  printer_notConnected: string;
  printer_connected: string;
  tryAgain: string;
  currentlyServing: string;
  counter: string;
  booking_haveYouBooked: string;
  booking_yesHaveBooked: string;
  booking_noHaveBooked: string;
  no: string;
  booking_inputCheckInCode: string;
  back: string;
  ok: string;
  close: string;
  cancel: string;
  booking_invalidCheckInCode: string;
  booking_inputCheckInPlaceholder: string;
  booking_invalidCheckInCodeServer: string;
  booking_successCheckIn: string;
  feedback_excellent: string;
  feedback_good: string;
  feedback_indifferent: string;
  feedback_bad: string;
  feedback_other: string;
  feedback_sendIn: string;
  feedback_thanks: string;
  feedback_haveNiceDay: string;
}

type LanguageTranslation = {
  [key in Locale]: TranslationKeys;
};

export const COMMON_TRANSLATIONS: LanguageTranslation = {
  'sv-SE': {
    welcomeTo: 'Välkommen till',
    printingToken: 'Kölapp skrivs ut',
    yourQueueNumber: 'Ditt könummer',
    getTicketHere: 'Dra kölapp här',
    getPaperTicketHere: 'Dra papperskölapp här',
    otherServices: 'Andra tjänster',
    digitalTicketOnPhone: 'Digital kölapp på mobiltelefon',
    scanQrForDigitalTicket:
      'Skanna QR-kod för digital kölapp! Följ kön på mobilen och fortsätt handla medan du väntar på din tur.',
    scanQrDigitalUpdates: 'Skanna QR-koden för digital kölapp\noch få uppdateringar på mobilen',
    cannotPrintPaperTicket: 'Kan inte skriva ut papperskölapp, var god skanna QR-koden ovan.',
    forPaperTicket: 'För pappersbaserad kölapp:',
    qrBased_savePaper: 'Spara världen för papper',
    qrBased_useMobileCamera: 'Använd mobilkamera för att ta en digital kölapp',
    qrBased_instructions: 'Instruktioner',
    qrBased_instructionStep1: 'Öppna mobilkameran.',
    qrBased_instructionStep2: 'Håll mobilen så att QR-koden visas på mobilskärmen.',
    qrBased_instructionStep3: 'Tryck på anmälan som visas på mobilskärmen.',
    qrBased_instructionStep4: 'Välj den avdelning du vill besöka.',
    printer_noPaper: 'Skrivaren är tom på papper',
    printer_couldNotPrint: 'Kunde inte skriva ut kölapp, vänligen kontakta personalen',
    printer_notConnected: 'Skrivaren är inte kopplad',
    printer_connected: 'Skrivaren är kopplad',
    tryAgain: 'Försök igen',
    currentlyServing: 'Nu betjänas',
    counter: 'Disk',
    booking_haveYouBooked: 'Har du bokat online?',
    booking_yesHaveBooked: 'Ja, jag har kod',
    booking_noHaveBooked: 'Nej, Drop In',
    no: 'Nej',
    booking_inputCheckInCode: 'Ange kod från SMS',
    back: 'Tillbaka',
    ok: 'Ok',
    close: 'Stäng',
    cancel: 'Avbryt',
    booking_invalidCheckInCode: 'Koden måste vara 4 siffror',
    booking_inputCheckInPlaceholder: 'kod',
    booking_invalidCheckInCodeServer: 'Hittade inte bokning med kod',
    booking_successCheckIn: 'Du har meldt ankomst',
    feedback_excellent: 'Fantastisk',
    feedback_good: 'Bra',
    feedback_indifferent: 'Ok',
    feedback_bad: 'Dålig',
    feedback_other: 'Annat',
    feedback_sendIn: 'Skicka',
    feedback_thanks: 'Tack så mycket',
    feedback_haveNiceDay: 'Ha en fin dag!',
  },
  'nb-NO': {
    welcomeTo: 'Velkommen til',
    printingToken: 'Kølapp skrives ut',
    yourQueueNumber: 'Ditt kønummer',
    getTicketHere: 'Trekk kølapp her',
    getPaperTicketHere: 'Trekk papirkølapp her',
    otherServices: 'Andre tjenester',
    digitalTicketOnPhone: 'Digital kølapp på mobiltelefon',
    scanQrForDigitalTicket:
      'Skann QR-kode for digital kølapp! Følg køen på mobiltelefon, og fortsette handelen mens du venter på din tur.',
    scanQrDigitalUpdates: 'Skann QR-kode for digital kølapp\nog få oppdateringer på mobil',
    cannotPrintPaperTicket: 'Kan ikke printe ut papirkølapp, vennligst scan QR-koden over.',
    forPaperTicket: 'For papirbasert kølapp:',
    qrBased_savePaper: 'Spar verden for papir',
    qrBased_useMobileCamera: 'Bruk mobilkameraet til å ta en digital kølapp',
    qrBased_instructions: 'Instruksjoner',
    qrBased_instructionStep1: 'Åpne mobilkameraet.',
    qrBased_instructionStep2: 'Hold mobilen slik at QR-koden vises på mobilskjermen.',
    qrBased_instructionStep3: 'Trykk på varslingen som vises på mobilskjermen.',
    qrBased_instructionStep4: 'Velg den avdelingen du vil besøke.',
    printer_noPaper: 'Printer er tom for papir',
    printer_couldNotPrint: 'Kunne ikke printe ut kølapp, ta kontakt med betjeningen',
    printer_notConnected: 'Printer er ikke tilkoblet',
    printer_connected: 'Printer er tilkoblet',
    tryAgain: 'Prøv igjen',
    currentlyServing: 'Nå betjenes',
    counter: 'Kasse',
    booking_haveYouBooked: 'Har du forhåndsbooket?',
    booking_yesHaveBooked: 'Ja, jeg har kode',
    booking_noHaveBooked: 'Nei, Drop In',
    no: 'Nei',
    booking_inputCheckInCode: 'Tast inn kode fra SMS',
    back: 'Tilbake',
    ok: 'Ok',
    close: 'Lukk',
    cancel: 'Avbryt',
    booking_invalidCheckInCode: 'Kode må være 4 siffer',
    booking_inputCheckInPlaceholder: 'kode',
    booking_invalidCheckInCodeServer: 'Fant ikke booking med kode',
    booking_successCheckIn: 'Du har meldt ankomst',
    feedback_excellent: 'Fantastisk',
    feedback_good: 'Bra',
    feedback_indifferent: 'Ok',
    feedback_bad: 'Dårlig',
    feedback_other: 'Annet',
    feedback_sendIn: 'Send inn',
    feedback_thanks: 'Tusen takk',
    feedback_haveNiceDay: 'Ha en fin dag!',
  },
  'en-US': {
    welcomeTo: 'Welcome to',
    printingToken: 'Printing out ticket',
    yourQueueNumber: 'Your queue number',
    getTicketHere: 'Get queue slip here',
    getPaperTicketHere: 'Get paper queue slip here',
    otherServices: 'Other services',
    digitalTicketOnPhone: 'Digital queue slip on mobile phone',
    scanQrForDigitalTicket:
      'Scan QR code for a digital queue slip! Follow the queue on your phone and keep shopping while you wait for your turn.',
    scanQrDigitalUpdates: 'Scan QR code for a digital queue slip\nand get updates on your phone',
    cannotPrintPaperTicket: 'Cannot print paper queue slip, please scan the QR code above.',
    forPaperTicket: 'For paper-based queue slip:',
    qrBased_savePaper: 'Save unnecessary usage of paper',
    qrBased_useMobileCamera: 'Use your mobile camera to get a digital queueing ticket',
    qrBased_instructions: 'Instructions',
    qrBased_instructionStep1: `Open your phone's camera app.`,
    qrBased_instructionStep2: 'Point the camera on the QR code.',
    qrBased_instructionStep3: 'Press on the notification that appears on the display.',
    qrBased_instructionStep4: 'Choose the queue you wish to get in line for.',
    printer_noPaper: 'Printer out of paper',
    printer_couldNotPrint: 'Could not print queue slip, please contact staff',
    printer_notConnected: 'Printer is not connected, please contact staff',
    printer_connected: 'Printer connected successfully',
    tryAgain: 'Try again',
    currentlyServing: 'Currently serving',
    counter: 'Counter',
    booking_haveYouBooked: 'Have you booked online?',
    booking_yesHaveBooked: 'Yes, I have a code',
    booking_noHaveBooked: 'No, Drop In',
    no: 'No',
    booking_inputCheckInCode: 'Enter code from SMS',
    back: 'Back',
    ok: 'Ok',
    close: 'Close',
    cancel: 'Cancel',
    booking_invalidCheckInCode: 'Code must be 4 digits',
    booking_inputCheckInPlaceholder: 'code',
    booking_invalidCheckInCodeServer: 'Could not find booking with code',
    booking_successCheckIn: 'You have checked in',
    feedback_excellent: 'Fantastic',
    feedback_good: 'Good',
    feedback_indifferent: 'Ok',
    feedback_bad: 'Bad',
    feedback_other: 'Other',
    feedback_sendIn: 'Send',
    feedback_thanks: 'Thank You',
    feedback_haveNiceDay: 'Have a Nice Day!',
  },
};
